<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="属性">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
    <a-form-model-item label="编码">
      <a-input v-model="form.data.code"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
      <a-button type="primary" v-if="!goodsAttributeId" @click="onAdd">创建</a-button>
      <a-button type="primary" v-if="goodsAttributeId" @click="onUpdate">更新</a-button>
      <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryGoodsAttribute,
  _addGoodsAttribute,
  _updateGoodsAttribute,
} from '@/api/goodsAttributeApi';

async function getGoodsAttribute() {
  const result = await _queryGoodsAttribute(this.goodsCategoryId, this.goodsAttributeId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.code = result.code;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      await _addGoodsAttribute(
        this.goodsCategoryId,
        {
          name: this.form.data.name,
          code: this.form.data.code,
        },
      );
      if (this.onSubmitHandler) {
        this.$message.success('添加成功');
        this.onSubmitHandler();
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      await _updateGoodsAttribute(this.goodsCategoryId, this.goodsAttributeId, {
        name: this.form.data.name,
        code: this.form.data.code,
      });
      if (this.onSubmitHandler) {
        this.$message.success('更新成功');
        this.onSubmitHandler();
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'GoodsAttributeEdit',
  props: {
    goodsAttributeId: String,
    goodsCategoryId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    goodsAttributeId() {
      if (this.goodsAttributeId) {
        this.getGoodsAttribute();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getGoodsAttribute,
  },
  data() {
    return {
      form: {
        data: {
          name: '',
          code: '',
        },
        title: '',
      },
    };
  },
  created() {
    if (this.goodsAttributeId) {
      this.getGoodsAttribute();
    }
  },
};
</script>
